import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
function Tab01() {
  return (
    <div className="tab_01">
      <Tabs
        defaultActiveKey="profile"
        id="uncontrolled-tab-example"
        className="mb-3"
      >
        <Tab eventKey="공지사항" title="공지사항">
          <p>홈페이지 샘플 공지1</p>
          <p>홈페이지 샘플 공지2</p>
          <p>홈페이지 샘플 공지3</p>
          <p>홈페이지 샘플 공지4</p>
        </Tab>
        <Tab eventKey="갤러리" title="갤러리">
          <p>홈페이지 샘플 갤러리1</p>
          <p>홈페이지 샘플 갤러리2</p>
          <p>홈페이지 샘플 갤러리3</p>
          <p>홈페이지 샘플 갤러리4</p>
        </Tab>
      </Tabs>
    </div>
  );
}

export default Tab01;
